// extracted by mini-css-extract-plugin
module.exports = {"voorblad":"Nieuws_voorblad__rTHaj","container":"Nieuws_container__sqTTR","titel":"Nieuws_titel__FgVPk","intro":"Nieuws_intro__OnK6V"};